import React, { useState } from 'react';

import {
	ApButtonMain,
	ApButtonSecondary,
	ApCheckbox,
} from '@alixpartners/ui-components';

import { StyledModal } from './styles';

export const ConfirmationDialog = ({
	text,
	onClose,
	onConfirm,
	title,
	suppressCheckbox,
	confirmButton,
}) => {
	const [notShowDialog, setNotShowDialog] = useState(false);

	return (
		<StyledModal
			header={title || 'Category level change'}
			footer={() => (
				<React.Fragment>
					{!suppressCheckbox && (
						<ApCheckbox
							autoFocus
							theme="light"
							type="checkbox"
							defaultChecked={notShowDialog}
							onChange={() => setNotShowDialog(!notShowDialog)}
						>
							Don't show this message again
						</ApCheckbox>
					)}

					<ApButtonSecondary theme="light" onClick={onClose}>
						Cancel
					</ApButtonSecondary>
					{confirmButton || (
						<ApButtonMain
							theme="light"
							onClick={() => onConfirm(notShowDialog)}
						>
							Ok
						</ApButtonMain>
					)}
				</React.Fragment>
			)}
			hasClosed={onClose}
			isDismissible
			isOpen
			zIndex={998}
		>
			<div>{text}</div>
		</StyledModal>
	);
};
